/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadClaimedByFacility
 */
export interface LeadClaimedByFacility {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    id?: string;
}

/**
 * Check if a given object implements the LeadClaimedByFacility interface.
 */
export function instanceOfLeadClaimedByFacility(value: object): value is LeadClaimedByFacility {
    return true;
}

export function LeadClaimedByFacilityFromJSON(json: any): LeadClaimedByFacility {
    return LeadClaimedByFacilityFromJSONTyped(json, false);
}

export function LeadClaimedByFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadClaimedByFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function LeadClaimedByFacilityToJSON(json: any): LeadClaimedByFacility {
    return LeadClaimedByFacilityToJSONTyped(json, false);
}

export function LeadClaimedByFacilityToJSONTyped(value?: LeadClaimedByFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
    };
}

